import { AuthResponseDto } from '@goparrot/dashboard-gateway-sdk';
import { squareSsoFacade } from '../facades';

export const squareSsoLoginCallback = ({ code, state }): Promise<AuthResponseDto> => squareSsoFacade.callback(code, state);
